import { render } from "./NeobuqFormEditShip.vue?vue&type=template&id=c9b5a1b2&scoped=true&lang=true"
import script from "./NeobuqFormEditShip.vue?vue&type=script&lang=js"
export * from "./NeobuqFormEditShip.vue?vue&type=script&lang=js"

import "./NeobuqFormEditShip.vue?vue&type=style&index=0&id=c9b5a1b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b5a1b2"]])

export default __exports__